import React, { FC, useEffect, useState } from 'react'
import styled from '@emotion/styled'

import { useNftDetail } from 'core/nft/api/useNftDetail'
import { ACCOUNT_TEST } from 'shared/config'

import { Spin } from 'antd'
import { PageContainer } from 'components'
import { NftCustom } from './NftCustom'
import { NftOnBlockChain } from './NftOnBlockChain'

export const NftEdit: FC = () => {
    const { loading, detail } = useNftDetail()
    const [isLocal, setIsLocal] = useState(false)

    useEffect(() => {
        if (detail?.owner === ACCOUNT_TEST) {
            setIsLocal(false)
        }
    }, [detail, setIsLocal])

    return (
        <Spin spinning={loading}>
            <Container>
                <div className="title">Edit</div>
                {detail && (
                    <div className="edit-main">
                        {isLocal ? <NftCustom detail={detail} /> : <NftOnBlockChain detail={detail} />}
                    </div>
                )}
            </Container>
        </Spin>
    )
}

const Container = styled(PageContainer)`
    width: 580px;
    padding: 0 0 80px;
    .title {
        width: 100%;
        height: 128px;
        line-height: 128px;
        font-family: Roboto-Medium;
        font-size: 36px;
        color: #000000;
        letter-spacing: 0;
    }
`
